import Immutable, { Map } from 'immutable'
import { combineActions, handleActions } from 'redux-actions'
import ActionHelper from 'helpers/action'
import { RESET_STORE } from 'constants/index'

// constants
export const TRANSLATION_SENSOR_TYPE_FETCH_TABLE_DATA =
  'translations-sensor-type/TRANSLATION_SENSOR_TYPE_FETCH_TABLE_DATA'
export const [
  TRANSLATION_SENSOR_TYPE_FETCH_TABLE_DATA_SUCCESS,
  TRANSLATION_SENSOR_TYPE_FETCH_TABLE_DATA_FAILURE,
] = [
  `${TRANSLATION_SENSOR_TYPE_FETCH_TABLE_DATA}_SUCCESS`,
  `${TRANSLATION_SENSOR_TYPE_FETCH_TABLE_DATA}_FAILURE`,
]
export const TRANSLATION_SENSOR_TYPE_FETCH_FORM_DATA =
  'translations-sensor-type/TRANSLATION_SENSOR_TYPE_FETCH_FORM_DATA'
export const [
  TRANSLATION_SENSOR_TYPE_FETCH_FORM_DATA_SUCCESS,
  TRANSLATION_SENSOR_TYPE_FETCH_FORM_DATA_FAILURE,
] = [
  `${TRANSLATION_SENSOR_TYPE_FETCH_FORM_DATA}_SUCCESS`,
  `${TRANSLATION_SENSOR_TYPE_FETCH_FORM_DATA}_FAILURE`,
]
export const TRANSLATION_SENSOR_TYPE_CLEAR_STATE_LIST =
  'translations-sensor-type/TRANSLATION_SENSOR_TYPE_CLEAR_STATE_LIST'
export const TRANSLATION_SENSOR_TYPE_CLEAR_STATE_FORM =
  'translations-sensor-type/TRANSLATION_SENSOR_TYPE_CLEAR_STATE_FORM'
export const TRANSLATION_SENSOR_TYPE_CLEAR_STATE =
  'translations-sensor-type/CLEAR_STATE'
export const TRANSLATION_SENSOR_TYPE_CHANGE =
  'translations-sensor-type/TRANSLATION_SENSOR_TYPE_CHANGE'

// actions
export const translationsSensorTypeFetchTableData = ActionHelper.createActionObj(
  TRANSLATION_SENSOR_TYPE_FETCH_TABLE_DATA,
)
export const translationsSensorTypeClearStateList = ActionHelper.createActionObj(
  TRANSLATION_SENSOR_TYPE_CLEAR_STATE_LIST,
)
export const translationsSensorTypeClearState = ActionHelper.createActionObj(
  TRANSLATION_SENSOR_TYPE_CLEAR_STATE_FORM,
)
export const translationsSensorTypeClearStateForm = ActionHelper.createActionObj(
  TRANSLATION_SENSOR_TYPE_CLEAR_STATE,
)
export const translationsSensorTypeFetchFormData = ActionHelper.createActionObj(
  TRANSLATION_SENSOR_TYPE_FETCH_FORM_DATA,
)
export const translationsSensorTypeChange = ActionHelper.createActionObj(
  TRANSLATION_SENSOR_TYPE_CHANGE,
)

// store
const initialState = Immutable.fromJS({
  loading: true,
  tableData: {
    data: [],
    count: 0,
  },
  formData: {
    translations: [],
  },
})
const loadingActive = state => state.set('loading', true)

const jobSensorTypeTranslations = handleActions(
  {
    [combineActions(
      TRANSLATION_SENSOR_TYPE_FETCH_TABLE_DATA_SUCCESS,
      TRANSLATION_SENSOR_TYPE_CHANGE,
    )]: loadingActive,
    [combineActions(TRANSLATION_SENSOR_TYPE_CLEAR_STATE, RESET_STORE)]: () =>
      initialState,
    [TRANSLATION_SENSOR_TYPE_FETCH_TABLE_DATA_SUCCESS]: (state, action) =>
      state.set('tableData', Map(action.payload)),
    [TRANSLATION_SENSOR_TYPE_FETCH_FORM_DATA_SUCCESS]: (state, action) =>
      state.set('formData', Map(action.payload)),
  },
  initialState,
)

export default jobSensorTypeTranslations
